var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 149,
    viewBox: "0 0 295 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23883 137.829C-8.28405 123.513 6.18206 85.2099 27.9982 61.786C54.5271 33.3081 91.0981 9.3528 161.792 17.4991C220.167 24.2292 256.407 53.7399 268.735 68.9389C288.337 93.0972 302.499 127.185 290.693 141.282C270.882 164.946 189.027 124.683 144.627 123.862C100.227 123.041 35.4401 169.746 5.23883 137.829Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.007 114.957H60.9228L28.5136 8.76017C28.2034 7.74608 28.1352 6.67319 28.3144 5.62786C28.4936 4.58252 28.9153 3.59396 29.5455 2.74173C30.1756 1.88951 30.9967 1.19744 31.9425 0.721236C32.8884 0.245031 33.9326 -0.002006 34.9911 1.22679e-05H174.92C176.368 -0.000114184 177.779 0.465884 178.943 1.32938C180.108 2.19288 180.965 3.40824 181.388 4.79647L215.007 114.957Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.773 102.315H79.2299C77.7681 102.314 76.345 101.844 75.1697 100.973C73.9945 100.102 73.1291 98.8761 72.7009 97.4756L48.1586 17.0526C48.0023 16.5424 47.9677 16.0025 48.0576 15.4764C48.1475 14.9503 48.3594 14.4528 48.6763 14.0237C48.9931 13.5946 49.406 13.2461 49.8818 13.0061C50.3576 12.7661 50.883 12.6414 51.4156 12.6419H161.957C163.419 12.6422 164.842 13.1124 166.017 13.9834C167.192 14.8544 168.058 16.0803 168.486 17.4808L193.029 97.9038C193.185 98.4141 193.22 98.954 193.13 99.48C193.04 100.006 192.828 100.504 192.511 100.933C192.195 101.362 191.782 101.71 191.306 101.95C190.83 102.19 190.305 102.315 189.772 102.315H189.773Z",
    fill: "#202124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9229 114.956H267.892C268.583 114.957 269.268 115.093 269.907 115.358C270.545 115.624 271.126 116.012 271.615 116.502C272.103 116.992 272.491 117.574 272.756 118.214C273.02 118.854 273.156 119.54 273.156 120.233V127.282C273.156 128.681 272.601 130.022 271.614 131.012C270.627 132.001 269.288 132.557 267.892 132.557H66.1872C64.7911 132.557 63.4522 132.001 62.465 131.012C61.4778 130.022 60.9231 128.681 60.9229 127.282V114.956Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1475 61.3496L98.7358 47.2693",
    stroke: "#F5E2CF",
    strokeWidth: 6.34,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.708 61.3496L82.751 47.2693",
    stroke: "#F5E2CF",
    strokeWidth: 6.34,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.309 61.3496L160.897 47.2693",
    stroke: "#F5E2CF",
    strokeWidth: 6.34,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.87 61.3496L144.909 47.2693",
    stroke: "#F5E2CF",
    strokeWidth: 6.34,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.195 70.252C117.195 70.252 127.063 64.7987 137.086 70.252",
    stroke: "#F5E2CF",
    strokeWidth: 6.34,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.963 53.632C223.822 53.6292 222.716 53.2355 221.828 52.5164C220.941 51.7972 220.325 50.7957 220.084 49.6779C219.156 45.4861 218.567 42.2853 219.386 39.2913C220.369 35.7408 222.962 33.6621 225.755 31.6725C227.638 30.3349 228.945 28.3048 229.091 26.5052C229.133 25.9124 229.036 25.3178 228.807 24.7695C228.578 24.2213 228.223 23.7349 227.771 23.3497C224.842 20.5013 220.099 24.9333 219.886 25.1247C219.886 25.1247 215.902 28.5049 212.942 24.9607C209.981 21.4166 212.942 17.9028 212.942 17.9028C214.851 16.126 217.048 14.687 219.438 13.6473C225.136 11.2132 230.564 12.125 234.726 16.1524C236.232 17.5663 237.403 19.3003 238.152 21.227C238.902 23.1537 239.211 25.2242 239.057 27.2864C238.69 32.0829 235.881 36.7916 231.533 39.8719C229.492 41.3218 229.107 41.8354 229.013 41.9998C228.78 42.7414 229.55 46.2157 229.841 47.5259C230.002 48.2584 229.998 49.0177 229.828 49.7482C229.658 50.4788 229.327 51.1619 228.859 51.7475C228.391 52.3331 227.798 52.8063 227.124 53.1324C226.45 53.4585 225.712 53.6292 224.963 53.632Z",
    fill: "#FEC272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.374 71.0245C230.578 71.0245 233.175 68.421 233.175 65.2096C233.175 61.9981 230.578 59.3947 227.374 59.3947C224.17 59.3947 221.572 61.9981 221.572 65.2096C221.572 68.421 224.17 71.0245 227.374 71.0245Z",
    fill: "#FEC272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_1329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 149,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f59ec0a9f1c5856ce1ab62e83b713eaf.svg";
export { ForwardRef as ReactComponent };